/* eslint-disable max-len */
import {
  Card, Typography, Box, Skeleton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { ThumbsUp } from '../../../../icons/thumbs-up';
import { UsersGroup } from '../../../../icons/users-group';
import { Mail } from '../../../../icons/mail';
import { SystemStatisticsCardItem } from '../SystemStatisticsCardItem';
import style from './srtyle';

type TimedSystemStatisticsSectionProps = {
  daysBack: number,
  isLoading: boolean,
  outreachData: OutreachSystemStatistics | undefined,
  matchesData: MatchesSystemStatistics | undefined,
}

export default function TimedSystemStatisticsSection({
  daysBack,
  isLoading,
  outreachData,
  matchesData,
}: TimedSystemStatisticsSectionProps): JSX.Element {
  const [likedCard, setLikedCard] = useState<SystemStatisticsCard>({
    title: 'Liked',
    color: 'action.active',
    amount: '0',
    icon: (
      <UsersGroup
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [contactedCard, setContactedCard] = useState<SystemStatisticsCard>({
    title: 'Contacted',
    color: 'action.active',
    amount: '0',
    icon: (
      <Mail
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [repliedCard, setRepliedCard] = useState<SystemStatisticsCard>({
    title: 'Replied',
    color: 'success.main',
    amount: '0',
    icon: (
      <ThumbsUp
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [acceptanceRateCard, setAcceptanceRateCard] = useState<SystemStatisticsCard>({
    title: 'Acceptance Rate',
    color: 'action.active',
    amount: '0%',
    icon: (
      <ThumbsUp
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [trimmedAcceptanceRateCard, setTrimmedAcceptanceRateCard] = useState<SystemStatisticsCard>({
    title: 'Trimmed Acceptance Rate',
    color: 'action.active',
    amount: '0%',
    icon: (
      <ThumbsUp
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });

  useEffect(() => {
    if (!isLoading) {
      const updatedLikedCard = { ...likedCard, amount: outreachData?.totalConversations?.toString()  || '0' };
      const updatedContactedCard = { ...contactedCard, amount: outreachData?.contacted?.toString() || '0' };
      const updatedRepliedCard = { ...repliedCard, amount: `${((outreachData?.replyRate || 0) * 100)?.toFixed()}% (${outreachData?.repliedConversations})` || '-' };
      const updatedAcceptanceRateCard = { ...acceptanceRateCard, amount: `${((matchesData?.acceptanceRate || 0) * 100)?.toFixed()}%` };
      const updatedTrimmedAcceptanceRateCard = { ...trimmedAcceptanceRateCard, amount: `${((matchesData?.trimmedAcceptanceRate || 0) * 100)?.toFixed()}%` };
      setLikedCard(updatedLikedCard);
      setContactedCard(updatedContactedCard);
      setRepliedCard(updatedRepliedCard);
      setAcceptanceRateCard(updatedAcceptanceRateCard);
      setTrimmedAcceptanceRateCard(updatedTrimmedAcceptanceRateCard);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const renderCard = (card: SystemStatisticsCard): JSX.Element => {
    if (isLoading) {
      return (
        <Skeleton
          width={ style.skeleton.width }
          height={ style.skeleton.height }
          variant={ style.skeleton.variant }
          sx={ style.skeleton.sx }
        />
      );
    }

    return (
      <SystemStatisticsCardItem
        icon={ card.icon }
        title={ card.title }
        amount={ card.amount }
        color={ card.color }
      />
    );
  };

  return (
    <Card sx={ style.containerCard }>
      <Typography style={ { padding: 16 } } variant="h6">
        Last {daysBack} days
      </Typography>
      <Box sx={ style.containerCardsBox }>
        { renderCard(acceptanceRateCard) }
        { renderCard(trimmedAcceptanceRateCard) }
      </Box>
      <Box sx={ style.containerCardsBox }>
        { renderCard(likedCard) }
        { renderCard(contactedCard) }
        { renderCard(repliedCard) }
      </Box>
    </Card>
  );
}
